import { ReactionScheme } from './ReactionScheme';
import { Header } from './Header';

/**
 * Authenticated main UI (reaction scheme editor). Auth gate lives at the router level (`/app`).
 */
export function MainWorkspace() {
  return (
    <div className="rxn-generator">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-blue-600 focus:text-white focus:rounded"
        style={{
          position: 'absolute',
          left: '-9999px',
          top: 'auto',
          width: '1px',
          height: '1px',
          overflow: 'hidden',
        }}
        onFocus={(e) => {
          e.currentTarget.style.position = 'fixed';
          e.currentTarget.style.left = '1rem';
          e.currentTarget.style.top = '1rem';
          e.currentTarget.style.width = 'auto';
          e.currentTarget.style.height = 'auto';
          e.currentTarget.style.overflow = 'visible';
          e.currentTarget.style.zIndex = '1000';
          e.currentTarget.style.padding = '0.5rem 1rem';
          e.currentTarget.style.backgroundColor = 'rgb(37 99 235)';
          e.currentTarget.style.color = 'white';
          e.currentTarget.style.borderRadius = '0.375rem';
        }}
        onBlur={(e) => {
          e.currentTarget.style.position = 'absolute';
          e.currentTarget.style.left = '-9999px';
          e.currentTarget.style.top = 'auto';
          e.currentTarget.style.width = '1px';
          e.currentTarget.style.height = '1px';
          e.currentTarget.style.overflow = 'hidden';
        }}
      >
        Skip to main content
      </a>

      <Header />

      <main id="main-content" className="flex-1" style={{ backgroundColor: 'white', overflow: 'hidden' }}>
        <div className="w-full h-full">
          <div className="bg-white h-full">
            <ReactionScheme />
          </div>
        </div>
      </main>
    </div>
  );
}
